import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ContactProvider } from "./context/ContactContext";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Home from "./pages/Home";

// Route-level code splitting — keeps heavy admin/portal bundles out of the public landing page.
const ServicePage = lazy(() => import("./pages/ServicePage"));
const LocationPage = lazy(() => import("./pages/LocationPage"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Tools = lazy(() => import("./pages/Tools"));
const Resources = lazy(() => import("./pages/Resources"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const CarrierPortal = lazy(() => import("./pages/CarrierPortal"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard").then((m) => ({ default: m.AdminDashboard })));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center" role="status" aria-live="polite">
    <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-700 animate-spin" />
    <span className="sr-only">Loading…</span>
  </div>
);

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="ffs-skip-link">Skip to main content</a>
      <BrowserRouter>
        <AuthProvider>
          <ContactProvider>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route path="/locations/:slug" element={<LocationPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/privacy" element={<LegalPage />} />
                <Route path="/terms" element={<LegalPage />} />
                <Route path="/cookies" element={<LegalPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/portal" element={<ProtectedRoute><CarrierPortal /></ProtectedRoute>} />
                {/* Legacy /dispatch retired — Operations Workspace lives in /admin */}
                <Route path="/dispatch" element={<Navigate to="/admin" replace />} />
                <Route path="/admin" element={<ProtectedRoute roles={["admin", "dispatcher"]}><AdminDashboard /></ProtectedRoute>} />
              </Routes>
            </Suspense>
          </ContactProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
